<cx-org-sub-list [previous]="false">
  <a actions class="link" routerLink="../">
    {{ 'organization.done' | cxTranslate }}
  </a>
</cx-org-sub-list>
